export enum FilterType {
	Default,
	Slider
}
